import { render, staticRenderFns } from "./payRecord.vue?vue&type=template&id=318cdacf&scoped=true&"
import script from "./payRecord.vue?vue&type=script&lang=js&"
export * from "./payRecord.vue?vue&type=script&lang=js&"
import style0 from "./payRecord.vue?vue&type=style&index=0&id=318cdacf&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "318cdacf",
  null
  
)

export default component.exports